import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useImperativeHandle,
  useLayoutEffect,
} from 'react';
import { FaPlus } from 'react-icons/fa';
import { HistoricoProcesso } from '../../../components/UI/HistoricoProcesso/HistoricoProcesso';
import { inspecionarProcessoPageController as controller } from '../inspecaoProcessoController';
import { loadingInspecaoProcessoController as loadingController } from '../loadingInspecaoProcessoController';
import useStyle, {
  Container,
  ButtonNovo,
  ActionsButtons,
  HistoricoGrid,
} from './EmailsProcessoStyles';
import DialogEmail from './DialogEmail/DialogEmail';
import DialogNew from '../../../layouts/FormDialog/DialogNew';
import { getCurrentIdUsuario } from '../../../helpers';

function EmailsProcessoComponent(
  {
    processo, numeroDias, setLoadings, idComercialPrincipal = null, ehFaseAcordoSeguro,
  },
  ref
) {
  const emailsRef = useRef();
  const style = useStyle();

  const [historicos, setHistoricos] = useState({});
  const [openButtonNovo, setOpenButtonNovo] = useState(false);

  const [dataCadastramento, setDataCadastramento] = useState(
    controller.makeDefaultDataCadastramento(numeroDias)
  );

  const [loadingHistorico, setLoadingHistorico] = useState(false);

  const idUsuarioLogado = getCurrentIdUsuario();

  const isComercialPrincipal = idComercialPrincipal === idUsuarioLogado;

  function moveScrollToTop() {
    emailsRef.current.scrollToTop();
  }

  const onClickButtonNovo = useCallback(() => {
    setOpenButtonNovo((oldValue) => !oldValue);
  }, []);

  const onClose = useCallback(() => {
    setOpenButtonNovo((oldValue) => !oldValue);
  }, []);

  async function addNextHistoricos() {
    setLoadingHistorico(true);
    setHistoricos(
      await controller.findHistoricoWhenScrolled(processo.id, historicos)
    );
    setLoadingHistorico(false);
  }

  const updatePageEmails = useCallback(async () => {
    setLoadings(loadingController.changeLoadingHistorico(true));
    try {
      const response = await controller.findHistoricosEmails(processo.id);
      setHistoricos(response.historicos || {});
    } catch (error) {
      console.error('Erro ao buscar emails atualizados:', error);
      setHistoricos({});
    } finally {
      setLoadings(loadingController.changeLoadingHistorico(false));
    }
  }, [processo.id, setLoadings]);

  useImperativeHandle(ref, () => ({
    moveScrollToTop,
  }));

  useLayoutEffect(() => {
    if (!numeroDias) {
      return;
    }
    const dataCadastro = controller.makeDefaultDataCadastramento(numeroDias);
    setDataCadastramento(dataCadastro);
  }, [numeroDias]);

  useEffect(() => {
    if (!processo?.id) {
      return;
    }

    setLoadings(loadingController.changeLoadingHistorico(true));
    controller
      .findHistoricosEmails(processo.id)
      .then((res) => {
        setHistoricos(res.historicos);
      })
      .catch(() => {
        setHistoricos({});
      })
      .finally(() => {
        setLoadings(loadingController.changeLoadingHistorico(false));
      });
  }, [processo, numeroDias, setLoadings, dataCadastramento]);

  return (
    <Container>
      <DialogNew
        open={openButtonNovo}
        text="Novo E-mail"
        className={style.dialog}
      >
        <DialogEmail
          onClose={onClose}
          setLoadings={setLoadings}
          idProcesso={processo.id}
          updatePage={updatePageEmails}
        />
      </DialogNew>
      <ActionsButtons>
        {!ehFaseAcordoSeguro && (
          <ButtonNovo
            disabled={!isComercialPrincipal}
            variant="outlined"
            onClick={onClickButtonNovo}
          >
            <FaPlus />
            <span>Novo</span>
          </ButtonNovo>
        )}
      </ActionsButtons>
      <HistoricoGrid>
        <HistoricoProcesso
          ref={emailsRef}
          showLoading={loadingHistorico}
          historicos={historicos}
          addNextHistoricos={addNextHistoricos}
          isDisbaledChangePin
        />
      </HistoricoGrid>
    </Container>
  );
}
export const EmailsProcesso = React.memo(
  React.forwardRef(EmailsProcessoComponent)
);
